export const environment = {
  production: true,
  environment: 'production',
  api: 'https://hub-test.rdasup.com/apptest/api/v1/',
};
